import React from "react";
import styles from "../AsnPage.module.css";
import examplePoPdf from "../../../icons/example-po-pdf.svg";
import { Image } from "react-bootstrap";

const ExamplePurchaseOrder = (props) => {
  const { visible } = props;
  return (
    <>
      {visible && (
        <div className="example-po">
          <div className={styles.iconArea}>
            <Image className="mt-4" src={examplePoPdf} fluid />
          </div>
        </div>
      )}
    </>
  );
};

export default ExamplePurchaseOrder;
